import clsx from 'clsx';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { L, NotTranslated, T } from '../../../../../Translations';
import BigCheckmarkCircleIcon from '../../../../Cutesies/BigCheckmarkCircleIcon';
import Button from '../../../../Form/Button';
import Modal from '../../../../Modal';
import { Submitted } from './Types';
import ParticipantsStore from '../../../../../ParticipantsStore';

interface Props {
  state: Submitted;
  waiting: () => void;
  participantsStore: ParticipantsStore;
}

function ModalSubmitted({ state, waiting, participantsStore }: Props) {
  const action = state.resource.payload.licenseAction;
  const actionText = action === 'release' ? 'released' : 'allocated';
  const preposition = action === 'release' ? 'from' : 'to';
  const userCount = state.resource.payload.userIds.length;
  const done = () => {
    participantsStore.reloadList();
    waiting();
  };

  return (
    <Modal close={waiting} modalWidth="w-1/3" title="">
      <div className="flex flex-col w-full items-center">
        <BigCheckmarkCircleIcon width="160" height="160" />
        <div className="text-2xl font-bold mb-4">
          <T kind="License Update Successful" />
        </div>
        <div className="text-center mb-6">
          <T
            kind="You {{actionText}} the following license(s) {{preposition}}"
            actionText={actionText}
            preposition={preposition}
          />
          <span className="font-bold">
            <T kind="{{count}} participant(s)" count={userCount} />
          </span>
        </div>
        {state.resource.payload.allocatedOrReleasedLicenses.map(({ payload: license }) => (
          <div key={license.id} className="mb-4 text-center">
            <div className="font-bold text-lg mb-1">
              <NotTranslated text={license.name} />
            </div>
            <div className="text-gray-600">
              <T
                kind="Expires <date/>"
                date={<L localizeable={license.expiresOn} format={'short-month-day-year'} />}
              />
              {license.activationsRemaining
                .map((count) => (
                  <span>
                    {' | '}
                    <T kind="Activations Remaining: {{count}}" count={count} />
                  </span>
                ))
                .getOrElse(emptyFragment)}
            </div>
          </div>
        ))}
        <Button
          type="button"
          value="Done"
          onClick={done}
          data-intercom-target="bulk-license-assignment-done-button"
          className={clsx(
            'my-12 cursor-pointer w-72 rounded-md font-semibold',
            'bg-teal-600 px-4 py-2 text-base text-white',
          )}
        />
      </div>
    </Modal>
  );
}

export default observer(ModalSubmitted);
